import React, { useState, useEffect } from 'react';
import apiService, { errorHelpers, formatHelpers, authHelpers } from '../../../utils/apiService';


const SystemSettings = () => {
    const [fee, setFee] = useState('');
    const [currency, setCurrency] = useState('');  // still tracked, but never shown
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [alert, setAlert] = useState(null);

    // Load current settings on mount
    useEffect(() => {
        apiService.admin.getVerificationFee()
            .then(({ data }) => {
                setFee(data.settings.verification_fee);
                setCurrency(data.settings.currency);
            })
            .catch(err => {
                setAlert({ type: 'error', message: errorHelpers.getErrorMessage(err) });
            })
            .finally(() => setLoading(false));
    }, []);

    const handleSave = () => {
        setSaving(true);
        setAlert(null);
        apiService.admin.updateVerificationFee(fee, currency)
            .then(() => {
                setAlert({ type: 'success', message: 'Verification fee updated.' });
            })
            .catch(err => {
                setAlert({ type: 'error', message: errorHelpers.getErrorMessage(err) });
            })
            .finally(() => setSaving(false));
    };

    if (loading) return <p className="ss-loading">Loading settings…</p>;

    return (
        <div className="system-settings">
            <h2>⚙️ Verification Fee Settings</h2>

            {alert && (
                <div className={`alert alert-${alert.type}`}>
                    {alert.message}
                </div>
            )}

            <div className="form-card">
                <div className="form-group">
                    <label>Verification Fee</label>
                    <input
                        type="number"
                        min="0"
                        step="0.01"
                        value={fee}
                        onChange={e => setFee(e.target.value)}
                        disabled={saving}
                    />
                </div>

                {/* keep currency in state but hide from UI */}
                <input type="hidden" name="currency" value={currency} />

                <button
                    className="btn btn-primary save-btn"
                    onClick={handleSave}
                    disabled={saving}
                >
                    {saving ? 'Saving…' : 'Save Settings'}
                </button>
            </div>
            <style jsx>
                {`
        /* Container */
.system-settings {
  max-width: 450px;
  margin: 2rem auto;
  padding: 1rem;
  font-family: sans-serif;
}

/* Header */
.system-settings h2 {
  text-align: center;
  margin-bottom: 1.5rem;
  color: #333;
}

/* Loading text */
.ss-loading {
  text-align: center;
  color: #666;
}

/* Card around the form */
.form-card {
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 1.5rem;
  box-shadow: 0 2px 6px rgba(0,0,0,0.05);
}

/* Alerts */
.alert {
  margin-bottom: 1rem;
  padding: 0.75rem 1rem;
  border-radius: 4px;
  font-size: 0.95rem;
}
.alert-success {
  background: #e6ffed;
  color: #2d662d;
  border: 1px solid #b7e1b7;
}
.alert-error {
  background: #ffe6e6;
  color: #662d2d;
  border: 1px solid #e1b7b7;
}

/* Form groups */
.form-group {
  display: flex;
  flex-direction: column;
  margin-bottom: 1rem;
}
.form-group label {
  margin-bottom: 0.5rem;
  font-weight: 500;
  color: #555;
}
.form-group input[type="number"] {
  padding: 0.5rem 0.75rem;
  font-size: 1rem;
  border: 1px solid #ccc;
  border-radius: 4px;
}

/* Save button */
.save-btn {
  width: 100%;
  padding: 0.6rem;
  font-size: 1rem;
  border: none;
  border-radius: 4px;
  background-color: #007bff;
  color: #fff;
  cursor: pointer;
  transition: background-color 0.2s ease;
}
.save-btn:disabled {
  background-color: #a0c8f0;
  cursor: not-allowed;
}
.save-btn:not(:disabled):hover {
  background-color: #0069d9;
}

        `}
            </style>
        </div>
    );
};

export default SystemSettings;
